import { UpdateReplyDto } from '@diritto/common/reply/dtos/create-reply.dto';
import { ReplyApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ResponseDto } from '@diritto/common/base/response.dto';

type UpdateReplyVariables = { replyId: number; replyDto: UpdateReplyDto };

export const useUpdateReplyMutation = (options?: UseMutationOptions<ResponseDto, unknown, UpdateReplyVariables>) =>
  useMutation({
    mutationFn: ({ replyId, replyDto }: UpdateReplyVariables) => ReplyApi.updateReply(replyId, replyDto),
    ...options,
  });
